export const TESTIDS = {
  // Global
  appRoot: "cc-app-root",
  sidebar: "cc-sidebar",
  sidebarLogo: "cc-sidebar-logo",
  sidebarNavItem: (key) => `cc-nav-${key}`,
  sidebarProfile: "cc-sidebar-profile",
  sidebarSignOut: "cc-sidebar-signout",
  demoSwitcher: "cc-demo-switcher",
  demoSwitcherPlanning: "stage-switcher-planning",
  demoSwitcherVoyage: "stage-switcher-voyage",
  demoSwitcherPortDay: "cc-demo-switcher-port-day",
  demoSwitcherMemories: "stage-switcher-memories",

  // Auth / Login
  loginRoot: "cc-login-root",
  loginEmailInput: "cc-login-email",
  loginPasswordInput: "cc-login-password",
  loginSubmit: "cc-login-submit",
  loginError: "cc-login-error",
  loginProvider: (id) => `cc-login-provider-${id}`,
  loginDevSwitcher: "cc-login-dev-switcher",
  loginDevRole: (roleId) => `cc-login-dev-role-${roleId}`,

  // Planning
  planningRoot: "cc-planning-root",
  planningHero: "cc-planning-hero",
  countdownDays: "cc-countdown-days",
  countdownHours: "cc-countdown-hours",
  countdownMinutes: "cc-countdown-minutes",
  countdownSeconds: "cc-countdown-seconds",
  planningReadiness: "cc-planning-readiness",
  planningMilestones: "cc-planning-milestones",
  planningRoutePreview: "cc-planning-route",
  planningExcursions: "cc-planning-excursions",
  planningDining: "cc-planning-dining",
  planningPacking: "cc-planning-packing",
  planningDocuments: "cc-planning-documents",

  // Voyage
  voyageRoot: "cc-voyage-root",
  voyageMapHero: "cc-voyage-map-hero",
  voyageSchedule: "cc-voyage-schedule",
  voyageNextPort: "cc-voyage-next-port",
  voyageDining: "cc-voyage-dining",
  voyageSpending: "cc-voyage-spending",
  voyageSpendingAdd: "cc-voyage-spending-add",
  voyageOnboard: "cc-voyage-onboard",

  // Memories
  memoriesRoot: "cc-memories-root",
  memoriesHero: "cc-memories-hero",
  memoriesHighlights: "cc-memories-highlights",
  memoriesGallery: "cc-memories-gallery",
  memoriesStats: "cc-memories-stats",
  memoriesSpending: "cc-memories-spending",
  memoriesNextCruise: "cc-memories-next-cruise",

  // Administration
  adminRoot: "cc-admin-root",
  adminTab: (key) => `cc-admin-tab-${key}`,
  adminUsersTable: "cc-admin-users-table",
  adminCreateUserToggle: "cc-admin-create-user-toggle",
  adminUserNameInput: "cc-admin-user-name",
  adminUserEmailInput: "cc-admin-user-email",
  adminUserPasswordInput: "cc-admin-user-password",
  adminUserRolesSelect: "cc-admin-user-roles",
  adminUserSubmit: "cc-admin-user-submit",
  adminUserDelete: (id) => `cc-admin-user-delete-${id}`,
  adminRoleCard: (id) => `cc-admin-role-${id}`,
  // Magic-link invites (1.1.0)
  adminInvitesPanel: "cc-admin-invites-panel",
  adminInviteToggle: "cc-admin-invite-toggle",
  adminInviteEmail: "cc-admin-invite-email",
  adminInviteName: "cc-admin-invite-name",
  adminInviteRoles: "cc-admin-invite-roles",
  adminInviteSubmit: "cc-admin-invite-submit",
  adminInviteError: "cc-admin-invite-error",
  adminInvitesTable: "cc-admin-invites-table",
  adminInviteRow: (id) => `cc-admin-invite-row-${id}`,
  adminInviteResend: (id) => `cc-admin-invite-resend-${id}`,
  adminInviteRevoke: (id) => `cc-admin-invite-revoke-${id}`,
  adminInvitePreviewCopy: (id) => `cc-admin-invite-copy-${id}`,

  // Sprint 2 · Create Cruise Workflow (restored & modernized from
  // Foundation Freeze deletion · see BLOCKER_001_RESTORATION_NOTE)
  createCruiseRoute: "cc-create-cruise-route",
  createCruiseModal: "cc-create-cruise-modal",
  createCruiseTitle: "cc-create-cruise-title",
  createCruiseClose: "cc-create-cruise-close",
  createCruiseStart: "cc-create-cruise-start",
  createCruiseChooseUpload: "cc-create-cruise-choose-upload",
  createCruiseChooseManual: "cc-create-cruise-choose-manual",
  createCruisePDF: "cc-create-cruise-pdf",
  createCruisePDFDropzone: "cc-create-cruise-pdf-dropzone",
  createCruisePDFFile: "cc-create-cruise-pdf-file",
  createCruisePDFUploading: "cc-create-cruise-pdf-uploading",
  createCruisePDFError: "cc-create-cruise-pdf-error",
  createCruisePDFBack: "cc-create-cruise-pdf-back",
  createCruisePDFFallback: "cc-create-cruise-pdf-fallback",
  createCruiseManual: "cc-create-cruise-manual",
  createCruiseManualStepTitle: "cc-create-cruise-manual-step-title",
  createCruiseManualLine: "cc-create-cruise-manual-line",
  createCruiseManualLineOption: "cc-create-cruise-manual-line-option",
  createCruiseManualLineCreate: "cc-create-cruise-manual-line-create",
  createCruiseManualShip: "cc-create-cruise-manual-ship",
  createCruiseManualShipOption: "cc-create-cruise-manual-ship-option",
  createCruiseManualSail: "cc-create-cruise-manual-sail",
  createCruiseManualReturn: "cc-create-cruise-manual-return",
  createCruiseManualName: "cc-create-cruise-manual-name",
  createCruiseManualNext: "cc-create-cruise-manual-next",
  createCruiseManualBack: "cc-create-cruise-manual-back",
  createCruiseManualCreate: "cc-create-cruise-manual-create",
  createCruiseManualMoreToggle: "cc-create-cruise-manual-more",
  createCruiseReview: "cc-create-cruise-review",
  createCruiseReviewLinePicker: "cc-create-cruise-review-line-picker",
  createCruiseReviewShipPicker: "cc-create-cruise-review-ship-picker",
  createCruiseReviewCreate: "cc-create-cruise-review-create",
  createCruiseReviewBack: "cc-create-cruise-review-back",
  createCruiseFieldGroups: "cc-create-cruise-field-groups",
  createCruiseFieldGroup: (key) => `cc-create-cruise-group-${key}`,
  createCruiseField: (key) => `cc-create-cruise-field-${key}`,
  createCruiseCommitting: "cc-create-cruise-committing",
  createCruiseError: "cc-create-cruise-error",
  createCruiseErrorRetry: "cc-create-cruise-error-retry",
  createCruiseInlineError: "cc-create-cruise-inline-error",

  // Portfolio row actions (already added earlier; keep here)
  cruisesRowOpen: (id) => `cc-cruises-row-open-${id}`,
  cruisesRowSelect: (id) => `cc-cruises-row-select-${id}`,
  cruisesRowEdit: (id) => `cc-cruises-row-edit-${id}`,
  cruisesRowDelete: (id) => `cc-cruises-row-delete-${id}`,
  cruisesRowBook: (id) => `cc-cruises-row-book-${id}`,
  cruisesRowUncancel: (id) => `cc-cruises-row-uncancel-${id}`,

  // Cruise Selector · CKB-040 v4 · LAW-005 · global session context.
  cruiseSelector: "cc-cruise-selector",
  cruiseSelectorTrigger: "cc-cruise-selector-trigger",
  cruiseSelectorMenu: "cc-cruise-selector-menu",
  cruiseSelectorOption: (id) => `cc-cruise-selector-option-${id}`,
  cruiseSelectorGroup: (key) => `cc-cruise-selector-group-${key}`,
  cruiseSelectorEmpty: "cc-cruise-selector-empty",
  cruiseSelectorReturnNext: "cc-cruise-selector-return-next",

  // Governance
  governanceRoot: "cc-governance-root",
  governanceRegister: "cc-governance-register",
  governanceSearch: "cc-governance-search",
  governanceFilterType: "cc-governance-filter-type",
  governanceFilterStatus: "cc-governance-filter-status",
  governanceNew: "cc-governance-new",
  governanceRow: (key) => `cc-governance-row-${key}`,
  governanceDrawer: "cc-governance-drawer",
  governanceEdit: "cc-governance-edit",
  governanceSave: "cc-governance-save",
  governanceStatusSelect: "cc-governance-status-select",
  governanceCreateDrawer: "cc-governance-create-drawer",
  governanceCreateType: "cc-governance-create-type",
  governanceCreateKey: "cc-governance-create-key",
  governanceCreateTitle: "cc-governance-create-title",
  governanceCreateSubmit: "cc-governance-create-submit",

  // Knowledge — retired · legacy Knowledge workspace consolidated
  // into the canonical Editorial Knowledge (CKB Studio) experience.
  // The KnowledgePicker utility (still used by Finances) keeps its
  // own inline testids; nothing else remains.

  // Travelers workspace
  travelersRoot: "cc-travelers-root",
  travelersPartyCard: (id) => `cc-travelers-party-${id}`,
  travelersDining: "cc-travelers-dining",
  travelersDocuments: "cc-travelers-documents",
  travelersEditButton: (id) => `cc-travelers-edit-${id}`,
  travelersEditEmptyCta: (id) => `cc-travelers-edit-empty-cta-${id}`,
  travelersManageBanner: "cc-travelers-manage-banner",
  // Party management (PD-013)
  travelersManagePartyBtn: "cc-travelers-manage-party-btn",
  travelersPartyModal: "cc-travelers-party-modal",
  travelersPartyModalClose: "cc-travelers-party-modal-close",
  travelersPartyModalMember: (id) => `cc-travelers-party-modal-member-${id}`,
  travelersPartyModalRemove: (id) => `cc-travelers-party-modal-remove-${id}`,
  travelersPartyModalRoleSelect: (id) => `cc-travelers-party-modal-role-${id}`,
  travelersPartyModalSeapass: (id) => `cc-travelers-party-modal-seapass-${id}`,
  travelersPartyModalAddExisting: "cc-travelers-party-modal-add-existing",
  travelersPartyModalAddExistingItem: (id) => `cc-travelers-party-modal-add-existing-${id}`,
  travelersPartyModalCreateForm: "cc-travelers-party-modal-create-form",
  travelersPartyModalCreateName: "cc-travelers-party-modal-create-name",
  travelersPartyModalCreateDob: "cc-travelers-party-modal-create-dob",
  travelersPartyModalCreateAgeBand: "cc-travelers-party-modal-create-age",
  travelersPartyModalCreateRole: "cc-travelers-party-modal-create-role",
  travelersPartyModalCreateSubmit: "cc-travelers-party-modal-create-submit",
  travelersPartyModalTabExisting: "cc-travelers-party-modal-tab-existing",
  travelersPartyModalTabCreate: "cc-travelers-party-modal-tab-create",
  travelersEditForm: (id) => `cc-travelers-edit-form-${id}`,
  travelersDietInput: (id) => `cc-travelers-diet-${id}`,
  travelersAllergiesInput: (id) => `cc-travelers-allergies-${id}`,
  travelersNotesInput: (id) => `cc-travelers-notes-${id}`,
  travelersAccessibilityInput: (id) => `cc-travelers-accessibility-${id}`,
  travelersSaveButton: (id) => `cc-travelers-save-${id}`,

  // Packing workspace
  packingRoot: "cc-packing-root",
  packingCategory: (id) => `cc-packing-category-${id}`,
  packingProgress: "cc-packing-progress",

  // Budget workspace
  budgetRoot: "cc-budget-root",
  budgetCategory: (id) => `cc-budget-category-${id}`,
  budgetSummary: "cc-budget-summary",

  // Finances workspace (BR-FINANCE-002 · parent of Budget + Expenses)
  financesRoot: "cc-finances-root",
  financesTab: (key) => `cc-finances-tab-${key}`,
  expensesRoot: "cc-expenses-root",

  // Cruise Binder workspace
  binderRoot: "cc-binder-root",
  binderCategory: (id) => `cc-binder-category-${id}`,
  // BR-BINDER-001 · Iter 58 · Publication Dashboard refresh
  binderHero: "cc-binder-hero",
  binderReadinessBand: "cc-binder-readiness-band",
  binderPublishCta: "cc-binder-publish-cta",
  binderLastPublished: "cc-binder-last-published",
  binderReadinessPanel: "cc-binder-readiness-panel",
  binderReadinessChip: (id) => `cc-binder-readiness-chip-${id}`,
  binderReadinessReveal: "cc-binder-readiness-reveal",
  binderCategoriesHeading: "cc-binder-categories-heading",
  binderSourceDocsHeading: "cc-binder-source-docs-heading",
  binderCategoryChip: (id) => `cc-binder-category-chip-${id}`,
  binderCategoryCta: (id) => `cc-binder-category-cta-${id}`,
  // BR-BINDER-001..002 · Iter 58c — Publish + History
  binderPublicationOptions: "cc-binder-publication-options",
  binderPublicationLatest: "cc-binder-publication-latest",
  binderPublicationDownload: "cc-binder-publication-download",
  binderPublishAgain: "cc-binder-publish-again",
  binderHistoryReveal: "cc-binder-history-reveal",
  binderHistoryRow: (id) => `cc-binder-history-row-${id}`,
  binderHistoryDownload: (id) => `cc-binder-history-download-${id}`,
  binderPublishError: "cc-binder-publish-error",

  // Voyages workspace
  voyagesRoot: "cc-voyages-root",
  voyagesTabs: "cc-voyages-tabs",
  voyagesSearch: "cc-voyages-search",
  voyagesShipCard: (id) => `cc-voyages-ship-${id}`,
  voyagesPortCard: (id) => `cc-voyages-port-${id}`,

  // Settings workspace
  settingsRoot: "cc-settings-root",
  settingsAccountCard: "cc-settings-account",

  // Ship Time (BR-TIME-001)
  voyageShipTime: "cc-voyage-ship-time",
  voyagePortTime: "cc-voyage-port-time",
  sidebarShipTime: "cc-sidebar-ship-time",
  sidebarAllAboard: "cc-sidebar-all-aboard",

  // Administration · FX Rates panel (Exchange Rate Admin UI · 2026-08-09)
  adminFxRoot: "cc-admin-fx-root",
  adminFxActiveCard: "cc-admin-fx-active-card",
  adminFxActiveAge: "cc-admin-fx-active-age",
  adminFxPendingCount: "cc-admin-fx-pending-count",
  adminFxRateChip: (code) => `cc-admin-fx-rate-chip-${code}`,
  adminFxRefreshStage: "cc-admin-fx-refresh-stage",
  adminFxRefreshActivate: "cc-admin-fx-refresh-activate",
  adminFxFilter: "cc-admin-fx-filter",
  adminFxFilterOption: (key) => `cc-admin-fx-filter-${key}`,
  adminFxTable: "cc-admin-fx-table",
  adminFxRow: (id) => `cc-admin-fx-row-${id}`,
  adminFxRowStatus: (id) => `cc-admin-fx-row-status-${id}`,
  adminFxApprove: (id) => `cc-admin-fx-approve-${id}`,
  adminFxReject: (id) => `cc-admin-fx-reject-${id}`,
  adminFxRejectDialog: "cc-admin-fx-reject-dialog",
  adminFxRejectNote: "cc-admin-fx-reject-note",
  adminFxRejectCancel: "cc-admin-fx-reject-cancel",
  adminFxRejectConfirm: "cc-admin-fx-reject-confirm",

  // Finance workspace · FX age badge (Exchange Rate Admin UI · 2026-08-09)
  financesFxBadge: "cc-finances-fx-badge",

  // OCC deep-linking contract (2026-08-09)
  occContextHeader: "cc-occ-context-header",
  occContextBack: "cc-occ-context-back",
  occContextQueueLabel: "cc-occ-context-queue-label",
  occContextFilterChip: (key) => `cc-occ-context-filter-${key}`,

  // Document Intelligence (PD-020) — Iteration 25
  docIntTrigger: "cc-docint-trigger",
  docIntModal: "cc-docint-modal",
  docIntStep: (step) => `cc-docint-step-${step}`,
  docIntFileInput: "cc-docint-file-input",
  docIntFileDrop: "cc-docint-file-drop",
  docIntTextArea: "cc-docint-text-area",
  docIntPhaseSelect: (phase) => `cc-docint-phase-${phase}`,
  docIntParticipant: (id) => `cc-docint-participant-${id}`,
  docIntNextBtn: "cc-docint-next",
  docIntBackBtn: "cc-docint-back",
  docIntCancelBtn: "cc-docint-cancel",
  docIntApplyBtn: "cc-docint-apply",
  docIntExtractedSegment: (idx) => `cc-docint-extracted-${idx}`,
  docIntEmptyState: "cc-docint-empty",
  docIntError: "cc-docint-error",
  docIntSuccess: "cc-docint-success",
  docIntRecentJobs: "cc-docint-recent-jobs",
  docIntRecentJob: (id) => `cc-docint-job-${id}`,
};
